import {useCallback} from 'react';
import {TimerCountUp} from '../../../../controls/agyle/timer';
import {bmColorGuide, getBedWaitTimerColor} from '../../bmUtils';

const BedManagementTimer = (props) => {
    const {time, timeTo, timerColorFn} = props;

    const appliedGetTimerColorFn = useCallback((...args) => timerColorFn ?
      timerColorFn(...args) :
      getBedWaitTimerColor(
        time,
        props.countDown,
        props.countDownTo,
        timeTo,
      ), [timerColorFn]);

    const getTimerColor = () => bmColorGuide[appliedGetTimerColorFn()];

    return (
        <div style={{
            color: getTimerColor(),
        }}>
            <TimerCountUp
                {...props}
                time={time}
            />
        </div>
    )
}

export default BedManagementTimer;